// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activate .tab .card-info[data-v-13665b3e]{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
